import { render, staticRenderFns } from "./m-support-buttons.vue?vue&type=template&id=6394212c&scoped=true&lang=pug&"
import script from "./m-support-buttons.vue?vue&type=script&lang=js&"
export * from "./m-support-buttons.vue?vue&type=script&lang=js&"
import style0 from "./m-support-buttons.vue?vue&type=style&index=0&id=6394212c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6394212c",
  null
  
)

export default component.exports